module.exports = __webpack_public_path__ + "kp.svg?bab86a2769bae956735f43562d7a0a6e";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/1x1/kp.svg
// module id = 1451
// module chunks = 0